// extracted by css-extract-rspack-plugin
export default {"cls1":"utils-cls1_mkp","cls2":"utils-cls2_hGs utils-cls1_mkp"};